import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/workShop'

/** 获取车间列表 */
export const workshopList = () => {
  return axios.get(`${rootApi}/list`)
}
